module.exports = __webpack_public_path__ + "static/SW0-4f1a1dc6b2961fd77fe19959ba84f525.jpg";